
import { mapActions } from "pinia/dist/pinia";
import { useUIStore } from "@/store/ui.store";
import { getRgbColorFromHexAsString } from "@/utils/dominantColorOptimiser";
import { defineComponent } from "vue";

export default defineComponent({
    name: "BaseView",
    methods: {
        // ui actions
        ...mapActions(useUIStore, ["setHideLogo"]),

        setCustomTheme() {
            if (this.$route.query.backgroundColor) {
                document.documentElement.style.setProperty("--background", getRgbColorFromHexAsString(this.$route.query.backgroundColor as string));
            }

            if (this.$route.query.primaryColor) {
                document.documentElement.style.setProperty("--primary", getRgbColorFromHexAsString(this.$route.query.primaryColor as string));
            }
        },
    },
});
